module.exports = __webpack_public_path__ + "static/media/location-arrow-green.210c8038.svg";